import {
    WALLET_BRL_BALANCE_ERROR,
    WALLET_BRL_BALANCE_SUCCESS,
    WALLET_BRL_BALANCE_LOAD,
    WALLET_BRL_CASHOUT_ERROR,
    WALLET_BRL_CASHOUT_SUBMIT,
    WALLET_BRL_CASHOUT_SUCCESS,
    WALLET_BRL_CASHIN_ERROR,
    WALLET_BRL_CASHIN_SUBMIT,
    WALLET_BRL_CASHIN_SUCCESS,
    WALLET_BRL_CASHIN_FILE
} from '../actionTypes'

const initialState = {
    isLoading: false,
    message: null,
    success: false,
    brlBalance: 0,
    cashSubmit: false,
    cashSuccess: true,
    cashInMessage: null,
    cashOutMessage: null,
    cashOutError: '',
    comprovante: false,
}

export default (state = initialState, action) => {
    switch(action.type) {

        case WALLET_BRL_CASHIN_SUBMIT:
            return {
                ...state,
                cashSubmit: true,
            }

        case WALLET_BRL_CASHIN_ERROR:
            return {
                ...state,
                cashSubmit: false,
                cashInMessage: action.payload.message,
                cashSuccess: false,
            }

        case WALLET_BRL_CASHIN_FILE:
            return {
                ...state,
                cashSubmit: false,
                cashSuccess: false,
                comprovante: false
            }
        
        case WALLET_BRL_CASHIN_SUCCESS:
            return {
                ...state,
                cashSubmit: false,
                cashInMessage: action.payload.message,
                cashSuccess: true
            }

        case WALLET_BRL_CASHOUT_SUBMIT:
            return {
                ...state,
                cashSubmit: true
            }
        
        case WALLET_BRL_CASHOUT_ERROR:
            return {
                ...state,
                cashSubmit: false,
                cashSuccess: false,
                cashOutMessage: action.payload.message,
                cashOutError: action.payload.error
            }
        
        case WALLET_BRL_CASHOUT_SUCCESS:
            return {
                ...state,
                cashSubmit: false,
                cashSuccess: true,
                cashOutMessage: action.payload.message
            }


        case WALLET_BRL_BALANCE_LOAD:
            return {
                ...state,
                isLoading: true
            }
            
        case WALLET_BRL_BALANCE_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                message: action.payload.message
            }

        case WALLET_BRL_BALANCE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                brlBalance: action.payload.balance,
                message: null
            }

        default:
            return state
    }
}